<template>
    <div id="main">
        <div class="cell">
            <div
                class="article-index"
                :class="{'red': index ==1,'orange':index==2,'blue': index == 3}"
                v-if="index >= 0"
            >{{index}}</div>
            <div class="single-article" :class="{'width-i': index >=0}">
                <div class="cell-text" @click="toArticleDetail(single)">
                    <p>{{ single.title }}</p>
                </div>
                <div class="text-spec" @click="toArticleDetail(single)" v-if="!hide">
                    <div class="spec-mulit" :class="{'hasimg': single.img}">{{single.description}}</div>
                    <div class="text-img" v-if="single.img">
                        <img :src="single.img" alt />
                    </div>
                </div>
                <div class="text-spec hide" @click="toArticleDetail(single)" v-else></div>
                <div class="text-icon">
                    <span v-if="create">
                        <span>创建时间：{{single.created}}</span>
                    </span>
                    <span v-else>
                        <span v-if="single.money > 0">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#icondaozhangshijian" />
                            </svg>
                            {{single.money}}
                        </span>
                        <span v-if="single.username">{{single.username}}</span>
                        <span>
                            <i class="el-icon-chat-dot-round"></i>
                            {{single.commentNum}}条评论
                        </span>
                        <span>
                            <i class="el-icon-star-on"></i>
                            {{single.collectNum}}
                        </span>
                    </span>
                    <span @click="share">
                        <i class="el-icon-s-promotion"></i>
                        分享
                    </span>
                </div>
            </div>
            <el-dialog
                :visible.sync="dialog"
                width="35%"
                center
                :close-on-click-modal="false"
                :lock-scroll="true"
            >
                <span slot="title" class="dialog-title">{{single.title}}</span>
                <div class="dialog-contianer">
                    <div class="dialog-btn">
                        <qr-code :text="codeText" :size="180" error-level="L"></qr-code>
                    </div>
                    <div class="share-code">
                        <p class="inviteCode" id="inviteCode" v-text="codeText"></p>
                        <el-button v-if="codeText" class="copy" @click="CopyUrl" type="primary">复制链接</el-button>
                    </div>
                    <div class="dialog-amount">手机扫描此二维码或复制链接分享</div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { baseUrlC } from '../../config';
    const HEIGHT =
        document.body.clientHeight || document.documentElement.clientHeight;
    const WIDTH = document.body.clientWidth || document.documentElement.clientWidth;
    export default {
        props: {
            single: {
                type: Object
            },
            type: {
                type: String
            },
            hide: {
                type: Boolean // 是否隐藏文章说明
            },
            create: {
                type: Boolean // 是否隐藏文章说明
            },
            index: {
                type: Number,
                default: -1
            }
        },
        data() {
            return {
                dialog: false
            };
        },
        computed: {
            codeText() {
                return `${baseUrlC}/article-details?id=${this.single.id}`;
                // return window.location.href
            }
        },
        created() {},
        mounted() {},
        watch: {},
        methods: {
            toArticleDetail(item) {
                console.log('iiii', item);
                if (this.$route.name != 'article-list') {
                    this.httpGet(this.$root.getCrumbsDetail, {
                        id: this.type == 'collection' ? item.aid : item.id,
                        type: 'article'
                    })
                        .then(result => {
                            // 面包屑
                            let breadObj = [
                                {
                                    id: result.id,
                                    path: 'article-list?id=' + result.id,
                                    name: result.title
                                }
                            ];
                            if (result.children.length) {
                                breadObj.push({
                                    id: result.children.id,
                                    path: 'article-list?id=' + result.children.id,
                                    name: result.children.title
                                });
                            }
                            this.$store.commit('setBreadArr', breadObj);
                        })
                        .catch(err => {
                            console.error('getCrumbsDetail-err', err);
                        });
                }
                this.$router.push({
                    name: 'article-details',
                    query: {
                        id: this.type == 'collection' ? item.aid : item.id
                    }
                });
            },
            share() {
                this.dialog = true;
            },
            CopyUrl(data) {
                var Url2 = document.getElementById('inviteCode').innerText;
                var oInput = document.createElement('input');
                oInput.value = Url2;
                document.body.appendChild(oInput);
                oInput.select(); // 选择对象
                document.execCommand('Copy'); // 执行浏览器复制命令
                oInput.className = 'oInput';
                oInput.style.display = 'none';
                this.$message({
                    message: '复制成功!',
                    type: 'success'
                });
            }
        },
        components: {}
    };
</script>

<style lang='stylus' rel='stylesheet/stylus' scoped>
    @import '~assets/main.styl';

    #main {
        padding: 0 24px;
        // padding-bottom: 0;
        background: white;
        max-width: 832px;
        // height 177px
    }

    .cell {
        flex-x(flex-start, flex-start);
        border-bottom: 1px solid #F0F0F0;
        position: relative;
    }

    .article-index {
        width: 22px;
        height: 22px;
        border-radius: 5px;
        background: #dcdcdc;
        flex-center();
        margin: 15px 5px;
        font-size: 16px;
        color: gray6;
        line-height: 22px;

        &.red {
            background: #e71f19;
            color: #fff;
        }

        &.orange {
            background: #ff7200;
            color: #fff;
        }

        &.blue {
            background: #009ee2;
            color: #fff;
        }
    }

    .single-article {
        // border-bottom: 1px solid #F0F0F0;
        font-size: 14px;
        color: gray6;
        line-height: 22px;
        width: 832px;
        flex-y(flex-start, flex-start);
        background: white;
        padding: 15px 0;
        font-family: 'SimSun';

        p {
            font-size: 18px;
            color: black;
            line-height: 26px;
        }

        &.last {
            border-bottom: 0px solid white;
        }

        &.width-i {
            width: calc(100% - 32px);
        }
    }

    .cell-text {
        text-align: left;
        max-width: 85%;
        height: 26px;
        ellipsis();

        p {
            width: 100%;
            font-weight: 600;
            ellipsis();
        }
    }

    .cell-text:hover {
        color: #1876F0;
        cursor: pointer;

        p {
            color: #1876F0;
            font-weight: bold;
        }
    }

    .text-spec {
        flex-x(flex-start);
        height: 104px;
        width: 100%;

        // max-width: 832px;
        &.hide {
            height: 10px;
        }

        .spec-mulit {
            // min-width: 650px;
            // max-width: 832px;
            max-height: 66px;
            width: 100%;
            flex-wrap: wrap;
            multi(3);
            overflow: hidden;
            position: relative;

            &.hasimg {
                width: calc(100% - 156px);
            }
        }

        .text-img {
            display: flex;
            float: right;
            margin-left: 26px;
            width: 156px;

            img {
                width: 156px;
                height: 104px;
                border-radius: 4px;
            }
        }
    }

    .text-spec:hover {
        color: #1876F0;
        cursor: pointer;

        p {
            color: #1876F0;
        }
    }

    .text-icon {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
        height: 17px;
        flex-x();

        i {
            font-size: 12px;
            margin-right: 5px;
        }

        svg {
            icon-c(12px, #197DFF);
            fill: #197DFF;
            margin-right: 5px;
        }

        span {
            margin-right: 16px;
            flex-x();
        }
    }

    .text-icon:hover {
        color: #1876F0;
        cursor: pointer;
    }

    >>>.el-dialog__header {
        flex-x(space-between);

        .dialog-title {
            font-size: 16px;
            color: gray3;
            line-height: 21px;
            text-align: left;
            width: 90%;
            ellipsis();
        }
    }

    .dialog-contianer {
        padding: 24px 0;
        flex-y();

        .dialog-amount {
            font-size: 20px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            margin-top: 20px;
            font-weight: 500;

            span {
                color: rgba(255, 87, 31, 1);
            }
        }

        .dialog-btn {
            flex-x();
            margin: 40px 0;

            svg {
                width: 16px;
                height: 16px;
                margin-right: 12px;
            }
        }

        .share-code {
            flex-y(center, flex-start);

            p {
                color: #197DFF;
                padding-bottom: 15px;
            }
        }
    }
</style>
